import { Box, IconButton, Option } from "@mui/joy";
import { PersonAddIcon } from "../../../styles/StyledMUI";
import DarkTypography from "../../common/DarkTypography";
import DarkSelect from "../../common/DarkSelect";
import { colorTokens, hrPanelMutedSx } from "../../../styles/globalStyles";
import type { UserWithRole } from "../../../api/auth/Auth.typed";
import { userDisplayName } from "../../../utils/userHelper";

export type LeaveBalanceAssociateBarProps = {
  availableEmployees: UserWithRole[];
  selectedUserIdToAdd: number;
  onUserChange: (userId: number) => void;
  onAssociate: () => void;
  disabled?: boolean;
};

export default function LeaveBalanceAssociateBar({
  availableEmployees,
  selectedUserIdToAdd,
  onUserChange,
  onAssociate,
  disabled = false,
}: LeaveBalanceAssociateBarProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        flexWrap: "wrap",
        p: { xs: 1.5, sm: 2 },
        ...hrPanelMutedSx,
        borderRadius: 0,
        borderBottom: `1px solid ${colorTokens.border.default}`,
      }}
    >
      <DarkTypography level="body-md" colorVariant="accent">
        Associer un salarié
      </DarkTypography>
      <DarkSelect
        value={selectedUserIdToAdd}
        onChange={(_, v) => onUserChange((v as number) ?? -1)}
        sx={{ minWidth: { xs: "100%", sm: 280 }, flex: { xs: "1 1 100%", sm: "0 1 auto" } }}
      >
        <Option value={-1}>Sélectionner un salarié</Option>
        {availableEmployees.map((e) => (
          <Option key={e.user.id} value={e.user.id}>
            {userDisplayName(e.user)}
          </Option>
        ))}
      </DarkSelect>
      <IconButton
        size="sm"
        variant="soft"
        color="success"
        onClick={onAssociate}
        disabled={selectedUserIdToAdd === -1 || disabled}
        aria-label="Associer le salarié"
      >
        <PersonAddIcon />
      </IconButton>
    </Box>
  );
}
